import { useEffect, useState } from "react";

const SUGGESTION_MIN_CHARS = 3;
const SUGGESTION_DELAY_MS = 350;

// Player name autocomplete over the shared name-suggestions endpoint. Pass the
// already-chosen name as `selected` to stop suggesting once one is picked.
export const usePlayerSuggestions = (
  text: string,
  selected: string | null = null
) => {
  const [options, setOptions] = useState<string[]>([]);

  useEffect(() => {
    const partial = text.trim();
    if (partial.length < SUGGESTION_MIN_CHARS || partial === selected) {
      setOptions([]);
      return undefined;
    }
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        const res = await fetch(
          `${
            process.env.REACT_APP_API
          }public/player-name-suggestions?partialName=${encodeURIComponent(
            partial
          )}`,
          { signal: controller.signal }
        );
        const list = await res.json();
        if (!controller.signal.aborted && Array.isArray(list)) {
          setOptions(list.slice(0, 8));
        }
      } catch {
        // Suggestions are a convenience; typing a full name still works.
      }
    }, SUGGESTION_DELAY_MS);
    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [text, selected]);

  return [options, setOptions] as const;
};
